import { useRef, useState } from 'react'

import photoIcon from '../../imgs/pc-actions/photo-package-icon.svg'
import photoCompletedIcon from '../../imgs/pc-actions/photo-package-icon-completed.svg'
import photoDisabledIcon from '../../imgs/pc-actions/photo-package-icon-disabled.svg'
import Tooltip from '../Tooltip'

export const photoButtonTexts = {
  default: 'צילום חבילה',
  disabled: 'צילום חבילה',
  cancel: 'ביטול צילום',
  download: 'להורדת התמונה',
  tooltipTitle: 'בקשה בטיפול',
  tooltipDescription: 'לא ניתן לשלוח בקשה לצילום כרגע',
}

export const PhotoButton = ({ item, onPhotoRequest, onCancelPhotoRequest, texts = photoButtonTexts }) => {
  const [visibleTooltip, setVisibleTooltip] = useState(false)
  const photoIconRef = useRef(null)

  const createTooltipCloser = isOpen => {
    if (!isOpen) {
      setVisibleTooltip(false)
    }
  }
  // Return request active and no photo - disabled
  if (item.isPaid || item.isShipped || (item.isReturnRequestActive && !item?.photo)) {
    return (
      <>
        <button className='tool-cont' onClick={() => setVisibleTooltip(true)}>
          <div className='tool-cont-img-bcg' ref={photoIconRef}>
            <img src={photoDisabledIcon} alt='Photo package disabled' />
          </div>
          <span>{texts.disabled}</span>
        </button>
        <Tooltip
          title={texts.tooltipTitle}
          description={texts.tooltipDescription}
          isTooltipOpen={visibleTooltip}
          setIsTooltipOpen={createTooltipCloser}
          triggerRef={photoIconRef}
        />
      </>
    )
  }

  // Default - can request photo
  if (!item.isPhotoRequestActive && !item?.photo) {
    return (
      <button className='tool-cont' onClick={onPhotoRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={photoIcon} alt='Photo package' />
        </div>
        <span>{texts.default}</span>
      </button>
    )
  }

  // Cancel photo request
  if (item.isPhotoRequestActive) {
    return (
      <button className='tool-cont' onClick={onCancelPhotoRequest}>
        <div className='tool-cont-img-bcg'>
          <img src={photoDisabledIcon} alt='Cancel photo' />
        </div>
        <span style={{ color: 'red' }}>{texts.cancel}</span>
      </button>
    )
  }

  // Photo request completed
  if (item?.photo) {
    return (
      <a className='tool-cont' href={item.photo} target='_blank' rel='noopener noreferrer'>
        <div className='tool-cont-img-bcg'>
          <img src={photoCompletedIcon} alt='Photo completed' />
        </div>
        <span>{texts.download}</span>
      </a>
    )
  }

  return null
}
